<template lang="pug">
.wow__step.wow__step--third
  BudgetsForm(
    ref="budgetsForm"
    :organization="organization"
    :duration-format="durationFormat"
    :has-budget="hasBudget"
    :budget-state="form"
    @clear-budget="handleClearBudget"
    @change-budget-field="handleChangeBudgetField"
  )
</template>

<script>
import { set } from 'lodash-es';
import BudgetsForm from '../../budgets/BudgetsForm.vue';
import { initialBudgetState, BUDGET_FORM_KEYS } from '~/utils/budget_utils';

export default {
  name: 'WorkOrdersBudgetStep',
  components: { BudgetsForm },
  props: {
    hasBudget: {
      type: Boolean,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    organization: {
      type: Object,
      required: true,
    },
    durationFormat: {
      type: String,
      required: true,
    },
  },
  methods: {
    // Non-silent: validates the budget form (nested observers) and surfaces errors.
    // No BudgetsForm rendered → nothing to validate, treat as valid.
    validate() {
      return this.$refs.budgetsForm?.validate?.() ?? true;
    },
    // Silent: validity only, no error messages — for Save gating.
    validateSilently() {
      return this.$refs.budgetsForm?.validateSilently?.() ?? true;
    },
    reset() {
      this.$refs.budgetsForm?.reset?.();
    },
    handleChangeBudgetField(field, val) {
      set(this.form, field, val);

      this.$emit('update-budget');
    },
    handleClearBudget() {
      Object.entries(initialBudgetState()).forEach(([field, value]) => {
        if (BUDGET_FORM_KEYS.includes(field)) {
          set(this.form, field, value);
        }
      });

      this.$emit('reset-budget');
    },
  },
};
</script>
